define(function (require) {

	//models
	const IPSModel = require('civicsBase/ipsModel');
	const map_extent_model = require('civicsModels/location/map_extent_model');

	//collections
	const IPSCollection = require('civicsBase/ipsModelCollection');
	const nearest_address_collection = require('civicsCollections/location/nearest_address_collection');
	const nearest_parcel_collection = require('civicsCollections/location/nearest_parcel_collection');
	const location_collection = require('civicsCollections/address_collection')

	//utilities
	const view_manager = require('civicsUtils/view_manager');
	const Big = require('civicsUtils/libraries/big');
	const loading_manager = require('civicsUtils/loading_manager');

	const CN = require('civicsUtils/constants');

	return {
		locationObjectShell: {
			addressId: null,//the ID of the IPS Address
			addressData: null,//The full dataset of the IPS Address
			parcelId: null,
			parcelData: null,
			Spatial: {
				xCoordinate: null,
				yCoordinate: null
			},
			selectedText: null,//The autocomplete text selected by the user
			locationNotes: null,//the text to be saved to the location notes field
			reviewMessage: null,//the message, if any, to be displayed in the confirmation/review
			method: null,//method can be click, locateMe, autocomplete, provided
			isValid: false, /*does this object currently represent a valid site to be saved? This can mean  a found/not
							found result on autocomplete, clicking, and locating.Basically as long as the user attempted
							a method this should be set to true. The only way this would not be set is if they are
							located OUTSIDE of the map extent/ extent from the portletconfig*/
			isExact: false, /* if the autocomplete service returned an IPS address or parcel ID, we don't need to display the "Location found, but alternative address might be used" text.*/
		},
		locationObject: {},
		centerMapOnCoordinatesAndPlacePin: function (coordinates) {
			var mdl = new IPSModel({
				Spatial: {
					internalSymbology: 'primarySite',
					xCoordinate: coordinates.x,
					yCoordinate: coordinates.y
				}
			});

			var col = new IPSCollection();
			col.add(mdl);
			this.trigger('collection:updated', {
				collection: col
			});
		},
		checkForSpatial: function (location) {
			var ret = false;
			if (location && location.Spatial && location.Spatial.xCoordinate && location.Spatial.yCoordinate) {
				ret = true;
			}
			return ret;
		},
		checkPrimarySiteConstraints: function (config) {
			var primarySiteHiddenByConstraints = false;
			//if we're hiding or set to display only, don't do anything.
			if (config.constraints &&
				config.constraints.primarySite &&
				(config.constraints.primarySite.hidden ||
					config.constraints.primarySite.readOnly)) {
				primarySiteHiddenByConstraints = true;
			}
			return primarySiteHiddenByConstraints;
		},
		clearUserLocation() {
			this.usersCurrentCoordinates = null;
		},
		getUsersLocation: function (mapExtent, locateMeTimeout) {
			this.resetLocation({ locateMe: true });
			var timeoutMilliseconds = 10000;//don't request location data more than once per ten seconds
			this.resetLocation({ locateMe: true });
			var geoDataPromise = $.Deferred();
			//set a timeout to resolve the geoDataPromise so we don't get stuck when a user's location is failing to return
			//this was a issue reported by daton specifically on phones.
			locateMeTimeout = locateMeTimeout ? locateMeTimeout : 7500;
			setTimeout(function () {
				geoDataPromise.resolve(false);
			}, locateMeTimeout);
			//grab a copy of the coords just in case they're about to be wiped.
			var tempCoords = $.extend({}, this.usersCurrentCoordinates);
			if (tempCoords && tempCoords.x && tempCoords.y) {//if we have coords, use them
				geoDataPromise.resolve(tempCoords);
			} else {
				//we dont have the coordinates saved. So we need to see if we can access them
				if (navigator.geolocation) {
					navigator.geolocation.getCurrentPosition((geoData) => {//success
						if (geoData.coords) {
							var coords = {
								x: geoData.coords.longitude,
								y: geoData.coords.latitude
							};
							if (this.isPointInExtent(coords, mapExtent)) {
								this.usersCurrentCoordinates = coords;
								this.resetLocation({ locateMe: true });
								geoDataPromise.resolve(this.usersCurrentCoordinates);
								setTimeout(this.clearUserLocation.bind(this), timeoutMilliseconds);
							} else {
								geoDataPromise.resolve(false);
							}
						} else {
							geoDataPromise.resolve(false);
						}

					}, () => {
						//fail
						geoDataPromise.resolve(false);
					}, {
						maximumAge: 10,
						timeout: 7500,	//Setting this to 2 seconds works for literally everyone but FF.
						//FF Needs _at least_ 5 seconds to use location services...even when they are HARDCODED into the config.
						//if we see issues in FF with locate me, my gut would be to bump this up further. it doesn't degrade
						//performance in other browsers, but allows FF to walk the coordinates to the user as slow as it likes.
						enableHighAccuracy: true
					});
				} else {
					geoDataPromise.resolve(false);
				}
			}
			return geoDataPromise;
		},
		fetchMapExtent: function (mapConfigName) {
			var prom = $.Deferred();
			var extentModel = new map_extent_model();
			extentModel.mapName = mapConfigName;
			extentModel.fetch().done(() => {
				prom.resolve(extentModel.toJSON());
			})
			return prom;
		},
		findCenterPoint: function (box) {
			if (box && box.length == 4) {
				var x1 = new Big(box[0]);
				var x2 = new Big(box[2]);
				var y1 = new Big(box[1]);
				var y2 = new Big(box[3]);

				var x = (x1.plus(x2)).div(2);
				var y = (y1.plus(y2)).div(2);
				return ({ x: x.toString(), y: y.toString() });
			}
			return null;
		},
		getCountryCode: function (cultureInfo) {
			var ret = 'US'
			var split = cultureInfo.split('-');
			if (split.length == 2) {
				ret = split[1];
			}
			return ret;
		},
		getExtentFromConfig(config) {
			var ret = '';
			if (config
				&& config.cdrNewLocation
				&& config.cdrNewLocation.autocompleteMinLat != ''
				&& config.cdrNewLocation.autocompleteMinLon != ''
				&& config.cdrNewLocation.autocompleteMaxLat != ''
				&& config.cdrNewLocation.autocompleteMaxLon != '') {
				ret = config.cdrNewLocation.autocompleteMinLat + ',' +
					config.cdrNewLocation.autocompleteMinLon + ',' +
					config.cdrNewLocation.autocompleteMaxLat + ',' +
					config.cdrNewLocation.autocompleteMaxLon
			}
			return ret;
		},
		mapClicked: function (res, extentSize) {
			if (res && res.raw && res.raw.args
				&& res.raw.args.in && res.raw.args.in.findOption) {
				var box = res.raw.args.in.findOption("box");
				var point = this.findCenterPoint(box);
				this.resetLocation({ click: true });
				this.locationObject.Spatial = {
					xCoordinate: point.x,
					yCoordinate: point.y
				}
				//when we click, we center and pin right away. we don't move based on what IPS address we find
				this.centerMapOnCoordinatesAndPlacePin(point);
				this.getIPSLocationForCoordinates(point, extentSize);
			}
			//console.log('map clicked', res)
		},
		//added a promise return to account for a provided primary site that is a coordinate. These are trying to access the map too quickly, resulting in an error.
		//instead, we will check the area around the point first here, and resolve
		getIPSLocationForCoordinates: function (coordinates, extentSize) {
			var retProm = $.Deferred();
			//console.log(coordinates);
			var nearestLocationCollection;
			if (this.getActiveAutocompleteFieldType().address) {
				nearestLocationCollection = new nearest_address_collection();
			} else {//parcel
				nearestLocationCollection = new nearest_parcel_collection();
			}
			nearestLocationCollection.coordinates = coordinates;
			nearestLocationCollection.extentSize = extentSize;
			nearestLocationCollection.returnClosestSite = true
			loading_manager.loading(true, this);
			nearestLocationCollection.fetch().done((response) => {
				//console.log('extent response',response.data);
				if (nearestLocationCollection.length == 1) {
					this.IPSLocationFound(nearestLocationCollection.models[0].toJSON())
				} else {
					this.IPSLocationNotFound(coordinates);
				}
				//console.log('Location Object Currently is: ',this.locationObject);
			}).always(() => {
				loading_manager.loading(false, this);
				retProm.resolve();
			});
			return retProm;
		},
		IPSLocationFound: function (location) {
			//log to IPS if there's no spatial data.
			if (!this.checkForSpatial(location)) {
				var error = this.getActiveAutocompleteFieldType().address ? 'No spatial data for address' : 'No spatial data for parcel ';
				error += location.id;
				view_manager.logError(error)
			}
			//we've already centered and pinned for click. now we do so for the other methods.
			if (!this.locationObject.method.click) {
				if (this.checkForSpatial(location)){
					this.centerMapOnCoordinatesAndPlacePin({
						//if the response has a record, it will always have a spatial with x/y. other wise it wouldn't have been found.
						x: location.Spatial.xCoordinate,
						y: location.Spatial.yCoordinate
					});
				}
			}
			this.locationObject.isValid = true;
			var translatePrefix = 'CIVICS.INSTRUMENT_SUBMIT.LOCATION.';
			if (this.getActiveAutocompleteFieldType().address) {
				this.locationObject.type = "address";
				this.locationObject.addressId = location.id;
				this.locationObject.addressData = location;
				if (this.locationObject.method.locateMe || this.locationObject.method.click || this.locationObject.method.provided) {
					this.setFieldToValue(location.displayText);
				}
			} else {//parcel
				this.locationObject.type = "parcel";
				this.locationObject.parcelId = location.id;
				this.locationObject.parcelData = location;
				if (this.locationObject.method.locateMe || this.locationObject.method.click || this.locationObject.method.provided) {
					this.setFieldToValue(location.parcelId);
				}
				translatePrefix = 'CIVICS.INSTRUMENT_SUBMIT.LOCATION.PARCEL_'
			}
			if (this.locationObject.method.locateMe) {
				this.locationObject.locationNotes = i18n.t(translatePrefix + 'FOUND_LOCNOTE_LOCATE_ME');
			} else if (this.locationObject.method.click) {
				this.displayMessage(i18n.t(translatePrefix + 'FOUND_MESSAGE_PIN'));
				this.locationObject.locationNotes = i18n.t(translatePrefix + 'FOUND_LOCNOTE_PIN');
				this.locationObject.reviewMessage = i18n.t(translatePrefix + 'FOUND_REVIEW_PIN');
			} else if (this.locationObject.method.autocomplete) {
				var acLocNotes = this.checkForSpatial(location) ? i18n.t(translatePrefix + 'FOUND_LOCNOTE_AUTOCOMPLETE') : i18n.t(translatePrefix + 'FOUND_LOCNOTE_AUTOCOMPLETE_NO_SPATIAL');
				this.locationObject.locationNotes = acLocNotes + ' || ' + this.locationObject.selectedText;
				//if we have an exact match (for instance, when using lucene) we don't need the review message.
				this.locationObject.reviewMessage = this.locationObject.isExact ? '' : i18n.t(translatePrefix + 'FOUND_REVIEW_AUTOCOMPLETE');
			} else if (this.locationObject.method.provided) {
				this.locationObject.locationNotes = i18n.t(translatePrefix + 'PREVIOUSLY_ENTERED_LOCATION');
			}
			this.storePrimarySiteId(this.locationObject);


			//console.log('Found ' + address.locationLine1 + '/' + address.locationLine2,address);
		},
		IPSLocationNotFound: function (coordinates) {
			//we've already centered and pinned for click. now we do so for the other methods.
			if (!this.locationObject.method.click) {
				this.centerMapOnCoordinatesAndPlacePin(coordinates);
			}
			this.locationObject.Spatial = {
				xCoordinate: coordinates.x,
				yCoordinate: coordinates.y
			}
			this.locationObject.isValid = true;
			var translatePrefix = 'CIVICS.INSTRUMENT_SUBMIT.LOCATION.';
			if (this.getActiveAutocompleteFieldType().parcel) {
				translatePrefix = 'CIVICS.INSTRUMENT_SUBMIT.LOCATION.PARCEL_';
			}

			if (this.locationObject.method.locateMe) {
				this.displayMessage(i18n.t(translatePrefix + 'NOT_FOUND_MESSAGE_LOCATE_ME'));
				this.locationObject.locationNotes = i18n.t(translatePrefix + 'NOT_FOUND_LOCNOTE_LOCATE_ME');
				this.locationObject.reviewMessage = i18n.t(translatePrefix + 'NOT_FOUND_REVIEW_LOCATE_ME');
			} else if (this.locationObject.method.click) {
				this.displayMessage(i18n.t(translatePrefix + 'NOT_FOUND_MESSAGE_PIN'));
				this.locationObject.locationNotes = i18n.t(translatePrefix + 'NOT_FOUND_LOCNOTE_PIN');
				this.locationObject.reviewMessage = i18n.t(translatePrefix + 'NOT_FOUND_REVIEW_PIN');
			} else if (this.locationObject.method.autocomplete) {
				//we don't display a message in this case.
				this.locationObject.locationNotes = i18n.t(translatePrefix + 'NOT_FOUND_LOCNOTE_AUTOCOMPLETE') + ' || ' + this.locationObject.selectedText;
				this.locationObject.reviewMessage = i18n.t(translatePrefix + 'NOT_FOUND_REVIEW_AUTOCOMPLETE');
			} else if (this.locationObject.method.provided) {
				this.locationObject.locationNotes = i18n.t(translatePrefix + 'NOT_FOUND_PREVIOUSLY_ENTERED_LOCATION');
			}
		},
		isPointInExtent(coordinates, extent) {
			//console.log('Is Coordinate in extent?', coordinates, extent);
			var ret = true;
			if (extent && extent.length > 0) {
				var split = extent.split(',');
				if (split.length == 4) {
					var minX = new Big(split[0]);
					var minY = new Big(split[1]);
					var maxX = new Big(split[2]);
					var maxY = new Big(split[3]);
					var x = new Big(coordinates.x);
					var y = new Big(coordinates.y);
					//the big library uses gte for >=, and lte for <=
					if (!(minX.lte(x) && maxX.gte(x)
						&& minY.lte(y) && maxY.gte(y))) {
						ret = false;
					}
				}
			} else {
				//if we don't have an extent at all, we can't really tell if it's in the extent.
				ret = false;
			}
			return ret;
		},
		//essentially we're trying to spoof the same data we would have produced using the old site view.
		//the old site view is used to display the sites on the review and confirmation pages.
		//see v_lov_sites.js, submitData function in step two of add instruments for more information.
		processLocationData: function (data) {
			//If we have no locationDetails (data.location), and the locationObject is empty, or the location object is not valid, bomb out.
			if ((data.location == null || data.location.length <= 0)
				&& (_.isEmpty(this.locationObject) || this.locationObject.isValid == false)) {
				return { hasPrimarySite: false };//trip up any validation, and/or continue without a location
			} else {
				data.hasPrimarySite = true;
			}

			data.address = { id: 1 };
			data.parcel = { id: 1 };
			data.Spatial = {};
			//we'll leave nonHansenPrimarySite null. It triggers some string concats in v_lov_add_instrument.js for the location
			//details field. We are going to be using the new location notes field for our extra location data instead
			data.nonHansenPrimarySite = null;
			data.associatedProperties = [];//no associated properties for CRM.
			data.selectedProperties = [];//used purely for display purposes in confirmation and review

			//new fields
			data.locationNotes = this.locationObject.locationNotes;

			//when we don't want to display the actual IPS Address, either because we used autocomplete or because we dont have it, we make a fake one
			//this is ONLY used in review and confirmation steps.
			var setFakeAddress = () => {
				data.selectedProperties.push({
					siteDescription: this.locationObject.selectedText,
					locationLine1: this.locationObject.selectedText,
					primarySite: true
				});
			}

			if (this.locationObject.addressId != null || this.locationObject.parcelId != null) {//if we have an IPS Address ID
				//this is the actual IPS Data that will get saved to the server. the important part is just the IDs
				if (this.getActiveAutocompleteFieldType().address) {
					data.address = this.locationObject.addressData;
				} else {
					data.parcel = this.locationObject.parcelData;
				}


				if (this.locationObject.method.autocomplete) {
					setFakeAddress();
				} else {
					//Here we want to show the IPS address/parcel in review and confirmation
					data.selectedProperties.push(this.getActiveAutocompleteFieldType().address ? this.locationObject.addressData : this.locationObject.parcelData);
					data.selectedProperties[0].primarySite = true;
				}
				//only track X/Y for pins
				if (this.locationObject.method.click && this.locationObject.Spatial.xCoordinate != null) {
					data.Spatial = this.locationObject.Spatial;
				}
				//we need to pass in the type so the review/confirmation pages can display the address/parcel appropriately.
				data.selectedProperties[0].type = this.getActiveAutocompleteFieldType().address ? 'address' : 'parcel';
			} else {//no IPS Data found.
				setFakeAddress();

				if (this.checkForSpatial(this.locationObject)) {
					data.Spatial = this.locationObject.Spatial;
					data.selectedProperties[0].Spatial = data.Spatial;
					data.selectedProperties[0].lat = data.Spatial.yCoordinate;
					data.selectedProperties[0].lon = data.Spatial.xCoordinate;
					data.selectedProperties[0].type = 'coords';
				}
			}
			data.selectedProperties[0].reviewMessage = this.locationObject.reviewMessage;
			//console.log('Proceeding with the following data:', data);
			return data;
		},
		//if site isn't null, then we got a primary site on load from cloning or continuing a saved site.
		processProvidedSite: function (site, extentSize, isClone) {
			if (site == null) {
				return;
			}
			if (this.config.scenarioID != null) {
				site = this.convertCPQSite(site);
			}
			var siteType = site.type ? site.type.trim().toLowerCase() : null;
			if(siteType== null) siteType = site["_siteType"] ? site["_siteType"].trim() : null;
			//when cloning, coordinates will have a site type of coords. when resuming a saved instrumnent, coords will NOT have a site type, hence the layers of ifs.
			if (siteType && (siteType == 'address' || siteType == 'parcel')) {
				if (siteType == 'address') {
					this.resetLocation({ provided: true });
					this.locationObject.isExact = true;
					this.getIPSDataForLocation({
						AddressKey: site.id
					}, isClone);
				} else if (siteType == 'parcel') {
					if (this.useBothAddressAndParcel) {
						this.setSiteType(CN.PARCEL);
					}
					//we have to reset the locaiton object AFTER setting the siteType, as that resets the location with a method of none.
					this.resetLocation({ provided: true });
					this.locationObject.isExact = true;
					this.getIPSDataForLocation({
						ParcelKey: site.id
					}, isClone);
				}
			} else {//Coords
				this.resetLocation({ click: true });
				var point;
				if (site.lon) {//when cloning
					point = { x: site.lon, y: site.lat }
				} else if (site.Spatial) {
					point = { x: site.Spatial.xCoordinate, y: site.Spatial.yCoordinate }
				}
				if (point != null) {
					//this must occur in this order due to the map ready promise not being reliable.
					//when the map ready promise resolves, it doesn't really mean the map is ready.
					//it means it will be ready soon. Searching for the IPS location first buys us some time.
					this.getIPSLocationForCoordinates(point, extentSize).done(() => {
						this.centerMapOnCoordinatesAndPlacePin(point);
					});
				}
			}

		},
		convertCPQSite: function (site) {
			if (site.type) {
				var type = site.type.toLowerCase();
				if (type == 'address') {
					site.id = site.address;
				} else if (type == 'parcel') {
					site.id = site.parcel
				} else if (type == 'coords') {
					//nothing to do here, already in correct format.
				}
			}
			return site;
		},
		resetLocation: function (mthd, keepAutocompleteText) {
			delete this.config.primarySiteObject;
			this.locationObject = $.extend({}, this.locationObjectShell, { method: mthd });
			//we want to just reset the object when we select an autocomplete option.
			//otherwise we would clear the autocomplete field too.
			if (!keepAutocompleteText === true) {
				this.clearAutocomplete();
			}
			this.displayMessage('');
			this.resetErrorMessages();
			this.trigger('collection:cleared');
		},
		determineSiteTypeToUse: function () {
			this.useAddress = false;
			this.useParcel = false;
			this.useBothAddressAndParcel = false;
			if (this.config.primarySiteType & CN.PARCEL) {
				this.useParcel = true;
			}
			if (this.config.primarySiteType & CN.ADDRESS) {
				this.useAddress = true;
			}
			if (this.useAddress && this.useParcel) {
				this.useBothAddressAndParcel = true;
			}
		},
		//Typically, when we get here we have a valid IPS key in the location parameter. However, in the case of cloning,
		//we may have a valid but EXPIRED or INNEFFECTIVE IPS key. This will result in a 404 error when fetching
		//when cloning, we want to hide that error. For other cases, we should display it as it is likely a valid error.
		//So, we pass in the this.config.isClone flag as the failQuietly parameter
		getIPSDataForLocation(location, failQuietly) {
			var locationCollection = new location_collection();
			if (this.getActiveAutocompleteFieldType().address) {
				locationCollection.urlAttributes = {
					passThroughString: 'id=' + location.AddressKey
				};
				locationCollection.siteType = 'address';
			} else {//parcel
				locationCollection.urlAttributes = {
					passThroughString: 'id=' + location.ParcelKey
				};
				locationCollection.siteType = 'parcel';
			}
			loading_manager.loading(true, this);
			locationCollection.fetch().done((response) => {
				this.IPSLocationFound(response.data);
				loading_manager.loading(false, this);
			}).fail((response, status, xhrResponse)=> {
				if (!failQuietly) {
					//if we fail here, we got an ID back from the autocomplete that doesn't exist in IPS. We're going to fail.
					view_manager.errorToWindow(response);
				}
				loading_manager.loading(false, this);
			});
		},
		autocompleteCallback: function (delegateResponse, selectedItem, extentSize) {
			//any excess data from the autocomplete data is stored in the model attribute. We're going to move it to the main object.
			var mdl = selectedItem.model ? selectedItem.model : {};
			delete selectedItem.model;
			//autocomplete adds a label based on whatever it's told to display. we don't want to overwrite that,
			//just in case the model has a label attribute we handle that here.
			if (mdl.label) {
				mdl.label_other = mdl.label
				delete mdl.label
			}
			var response = $.extend({}, selectedItem, mdl, delegateResponse);
			this.resetLocation({ autocomplete: true }, true);
			this.locationObject.selectedText = response.label;
			// 		//this is kinda unecessary, but it makes the process more consistent
			// 		//additionally it ensures the "oldValue" attr is set.
			this.setFieldToValue(response.label);

			//esri findaddresscandidate returns the spatial in the delegate as the location.
			if (response.location) {
				this.getIPSLocationForCoordinates(response.location, extentSize);
			} else {
				//lucene just returns us IDs and we will need to go fetch the proper parcel/address info ourselves
				this.locationObject.isExact = true;
				this.getIPSDataForLocation(response);
			}
		},
		//indication of primary site for the additional site functionality
		storePrimarySiteId: function(primarySite){
			this.config.primarySiteObject = {
				model: primarySite
			}
			return this.config.primarySiteObject;
		},
		setupAutocomplete: function (moniker, parameters, extentSize) {
			view_manager.setupAutoComplete(this, moniker, {
				urlParameters: parameters,
				selectedCallback: (delegateResponse, selectedItem) => {
					this.autocompleteCallback(delegateResponse, selectedItem, extentSize);
				},
				excludeItemCallback: (item) => {
					return item.entries.exclude === true;
				}
			});
		},
		//stubs
		buildLayerList: function () {
			return null;
		}
	}
});
